import ServerProfileForm from '../components/server-profile-form';

ManageIQ.component.addReact('ServerProfileForm', ServerProfileForm);
